import React, { Component } from 'react'
import { observer } from 'mobx-react'

import CompanyNavigation from './companynavigation'
import InvoiceList from '../invoices/invoicelist'
import Loadable from 'react-loading-overlay'

@observer(['companies', 'globals'])
export default class Invoices extends Component {

    constructor(props) {
      super(props)

      this.props.companies.loadCompanyDetails({ id: this.props.params.companyId, hash: localStorage.getItem('userHash') })

      this.state = {
        pageTitle: '',
        loadableState: true
      }

      this.loadInvoices()
    }

    loadInvoices(callback) {        
        this.props.companies.loadCompanyInvoices(this.props.params.companyId, () => {            
            this.setLoadableState(false)
            this.setState({
              pageTitle: 'Invoices ($' + this.props.companies.invoices.totalUnpaid.toFixed(2) + ' Unpaid)'
            })

            if (callback) {
                callback()
            }
        })
    }
    
    reload(callback) {
        this.loadInvoices(() => {
            this.setLoadableState(false)
            if (callback != null) {
                callback()
            }
        })
      }

    setLoadableState(loadableState) {
        this.setState({
            loadableState: loadableState
        })
    }

    render() {

        return (
            <div className="right_col" role="main" style={{ height: 'inherit' }}>
                <CompanyNavigation activeKey="2" companyId={this.props.params.companyId} companyStateId={this.props.companies.details.companyStateId} companyName={this.props.companies.details.name} />
                <div className="">
                    <div className="page-title">
                        <div className="title_left">
                        </div>
                    </div>
                    <div className="clearfix"></div>
                    <Loadable active={this.state.loadableState} spinner text='Processing your request...'>
                        <InvoiceList data={ this.props.companies.invoices } pageTitle={this.state.pageTitle} setLoadableState={ this.setLoadableState.bind(this) } reload={this.reload.bind(this)} />
                    </Loadable>
                </div>
            </div>
        )
    }
}



// WEBPACK FOOTER //
// ./src/components/company/invoices.js